import { render, staticRenderFns } from "./NewYorkClosing.vue?vue&type=template&id=89731b3a"
import script from "./NewYorkClosing.vue?vue&type=script&lang=js"
export * from "./NewYorkClosing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports